import { Injectable } from '@angular/core';
import {GeneralServicesImplService} from '../../services/general-services-impl.service';
import {HttpClient} from '@angular/common/http';
import * as servers from '../../services/api/servers';
import {urls} from '../../services/api/urls';
import {Observable} from 'rxjs';
import {ProjectConstants} from '../project-constants';
import {EmailTemplateModel} from '../../models/EmailTemplateModel';
import {UsersService} from '../users/service/users.service';
import {UserModel} from '../../models/UserModel';

@Injectable({
  providedIn: 'root'
})
export class TimetableService extends GeneralServicesImplService {

  baseUrl: string = servers.apiUrl + urls.emailTemplate;
  baseUrlEmailList: string = servers.apiUrl + urls.emailList;

  constructor(private httpClient: HttpClient, private usersService: UsersService) {
    super(httpClient);
  }

  getAllTemplates(): Observable<any> {
    const url = this.baseUrl + this.LINKS.FULL_EMAIL_TEMPLATE;
    const body = null;
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: null})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  getAllTimetableMailingList(templateList: EmailTemplateModel[]) {
    const url = this.usersService.baseUrl + this.LINKS.GET_MULTIPLE_TIMETABLE_MAILINGLIST;
    const body = templateList.map( x => x.id);
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: null})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }

  saveTimetable(templateId: number, sendTo: UserModel[], dateList: Date[]) {
    const url = this.baseUrlEmailList + this.LINKS.SAVE_TIMETABLE;
    const body = {
      templateId: templateId,
      userList: sendTo,
      dispatchDateList: dateList.map(d => d.getTime())
    };
    const header = ProjectConstants.returnGeneralHeader();
    return this.http.post( url, body, {headers: header, responseType: 'json', params: null})
      .pipe(
        // map (data => data) da inserire gestione errori
      );
  }
}
